import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import CustomizedProgressBar from "../../Components/LinearDeterminate";
import { CloseOutlined, KeyboardArrowLeft } from "@mui/icons-material";
import ProceduresBooking from "../../Components/ProceduresBooking";
import Button from "../../Components/Button";

function ReqMedical5() {
  const {
    selectedProcedureClass,
    selectedProcedures,
    setDisplayAlert,
    selectedClinic,
    handleBack,
    navigate,
    files,
  } = useRequestMedicalContext();

  function validateProcedures(procedures) {
    for (let procedure of procedures) {
      if (!procedure.date || !procedure.time) {
        return false;
      }
    }
    return true;
  }
  const stepFiveValidation =
    files.length > 0
      ? validateProcedures(selectedProcedureClass)
      : validateProcedures(selectedProcedures);

  function handleNext() {
    navigate("/request-medical-test/booking-summary");
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row p-3">
            <KeyboardArrowLeft
              className="cursor-pointer"
              onClick={handleBack}
            />
            <div className="text-center text-md font-bold flex-1">
              Request Medical Test
            </div>
            <CloseOutlined
              className=" cursor-pointer"
              onClick={() => setDisplayAlert(true)}
            />
          </div>
          <div className="p-3">
            <CustomizedProgressBar value={71.74} />
          </div>
        </div>
        <div className="w-full px-3 pb-3">
          <div className="text-[#60656D]">
            Choose your preferred date and time for each procedure
          </div>
          <div className="w-full bg-[#F6F7F7] mt-3 p-3 rounded-xl">
            <div className="s">
              <div className="font-bold">
                {selectedClinic?.providerName}
              </div>
              <div>{selectedClinic?.address}</div>
            </div>
          </div>
        </div>
        <ProceduresBooking />
        <div className="flex w-full p-4 mt-auto sm:justify-end">
          <Button
            disabled={!stepFiveValidation}
            className={`h-14 w-full sm:w-22.5 rounded-xl ${
              !stepFiveValidation ? "bg-[#F6F7F7]" : "bg-[#0053CC]"
            }`}
            onClick={handleNext}
          >
            <p
              className={`font-medium font-sans text-xs ${
                !stepFiveValidation ? "text-[#A3A7AB]" : "text-white"
              }`}
            >
              Continue
            </p>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ReqMedical5;
